import React from 'react';

import { getAdvancedSettings } from '../advancedSettings';
import { getBackgroundSettings } from '../backgroundSettings';
import { PageBuilderElementWrapper } from '../PageBuilderElementWrapper';

import type { ColumnGroupType } from './columnGroupConfigAggregator';
import classes from './PageBuilderColumnGroup.module.scss';

type PageBuilderColumnGroupProps = ColumnGroupType;

/**
 * Return the PB Column Group Block
 * @param props
 * @constructor
 */
export function PageBuilderColumnGroup(props: PageBuilderColumnGroupProps) {
    /**
     * Configure the styles requires for the Block
     */
    const backgroundStyles = getBackgroundSettings<PageBuilderColumnGroupProps>({ ...props });
    const advancedSettings = getAdvancedSettings<PageBuilderColumnGroupProps>(props);
    const layoutStyles = {
        minHeight: props.minHeight,
    };

    const columnGroupClassNames = [classes['root'], 'pageBuilderColumnGroupGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        columnGroupClassNames.push(...props.cssClasses);
    }

    const backgroundImageStyles = `
        #${props.uniqueID} {
            background-image: url(${props.mobileImage ?? props.desktopImage})
        }
    
        @media (min-width: 900px) {
            #${props.uniqueID} {
                background-image: url(${props.desktopImage})
            }
        }
    `;

    /**
     * Render the Column Group Block UI
     */
    return (
        <>
            {props.desktopImage && <style dangerouslySetInnerHTML={{ __html: backgroundImageStyles }} />}
            <PageBuilderElementWrapper
                contentType={props.contentType}
                uniqueID={props.uniqueID}
                styles={{
                    ...backgroundStyles,
                    ...advancedSettings,
                    ...layoutStyles,
                }}
                classNames={columnGroupClassNames}
            >
                {props.children}
            </PageBuilderElementWrapper>
        </>
    );
}
